import React, { useState, useEffect } from 'react';
import axios from 'axios';
import UserList from '../components/UserList';
import { Form, Button, Alert } from 'react-bootstrap';

const Users = () => {
  const [users, setUsers] = useState([]);
  const [formData, setFormData] = useState({ name: '', email: '', password: '', role: 'sales' });
  const [error, setError] = useState('');

  const fetchUsers = async () => {
    try {
      const response = await axios.get('http://localhost:5000/api/users');
      setUsers(response.data);
    } catch (err) {
      setError('Error obteniendo usuarios');
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.name || !formData.email || !formData.password) {
      setError('Todos los campos son obligatorios');
      return;
    }
    try {
      await axios.post('https://venticrm.unsoloclic.mx/api/users/register', formData);
      fetchUsers();
      setFormData({ name: '', email: '', password: '', role: 'sales' });
      setError('');
    } catch (err) {
      setError('Error registrando usuario');
    }
  };

  return (
    <div className="container mt-4">
      <h1>Usuarios</h1>
      {error && <Alert variant="danger">{error}</Alert>}
      <Form onSubmit={handleSubmit}>
        <Form.Group>
          <Form.Label>Nombre</Form.Label>
          <Form.Control
            type="text"
            value={formData.name}
            onChange={(e) => setFormData({ ...formData, name: e.target.value })}
            required
          />
        </Form.Group>
        <Form.Group>
          <Form.Label>Correo Electrónico</Form.Label>
          <Form.Control
            type="email"
            value={formData.email}
            onChange={(e) => setFormData({ ...formData, email: e.target.value })}
            required
          />
        </Form.Group>
        <Form.Group>
          <Form.Label>Contraseña</Form.Label>
          <Form.Control
            type="password"
            value={formData.password}
            onChange={(e) => setFormData({ ...formData, password: e.target.value })}
            required
          />
        </Form.Group>
        <Form.Group>
          <Form.Label>Rol</Form.Label>
          <Form.Control
            as="select"
            value={formData.role}
            onChange={(e) => setFormData({ ...formData, role: e.target.value })}
          >
            <option value="admin">Admin</option>
            <option value="sales">Ventas</option>
            <option value="collector">Cobrador</option>
          </Form.Control>
        </Form.Group>
        <Button type="submit" className="mt-3">Registrar Usuario</Button>
      </Form>
      <UserList users={users} fetchUsers={fetchUsers} />
    </div>
  );
};

export default Users;